import React from "react";
import { ArrowDown } from "lucide-react";

const HERO_PORTRAIT =
  "https://customer-assets.emergentagent.com/job_voice-demos-1/artifacts/nyci08pe_1_foto_homepage.png";

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen pt-32 pb-16 px-6 md:px-12"
      data-testid="hero-section"
    >
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-center min-h-[80vh]">
        {/* Left massive heading */}
        <div className="md:col-span-5 fade-up order-2 md:order-1">
          <h1
            className="heading-display text-[18vw] md:text-[8vw] lg:text-[7.5vw] text-[#F5F5F0]"
            data-testid="hero-title"
          >
            Mi voz
            <br />
            <span className="text-[#F25C32]">es</span> tu voz
          </h1>
          <div className="mt-8 flex items-center gap-3 text-[#9CA3AF] text-xs tracking-[0.3em] uppercase">
            <span className="w-10 h-px bg-[#F25C32]" />
            Voiceover Artist · Chile
          </div>
        </div>

        {/* Center portrait */}
        <div className="md:col-span-4 relative order-1 md:order-2 fade-up" style={{ animationDelay: "150ms" }}>
          <div className="relative aspect-[3/4] overflow-hidden rounded-sm">
            <img
              src={HERO_PORTRAIT}
              alt="Santiago Ramírez"
              className="grayscale-image w-full h-full object-cover"
              data-testid="hero-portrait"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a1024] via-transparent to-transparent" />
          </div>
        </div>

        {/* Right tagline */}
        <div className="md:col-span-3 fade-up order-3" style={{ animationDelay: "320ms" }}>
          <p className="heading-display text-2xl sm:text-3xl md:text-3xl lg:text-4xl text-[#F5F5F0] leading-[1.05]">
            <span className="text-[#F25C32]">Te juro</span> que me lo han dicho:{" "}
            <span className="text-[#F5F5F0]">"Santiago,</span>{" "}
            <span className="text-[#F5F5F0]">eres mucho más</span> que{" "}
            <span className="text-[#F5F5F0]">una bonita voz"</span>
          </p>

          <a
            href="#sobre-mi"
            className="mt-10 inline-flex items-center gap-3 text-sm tracking-[0.25em] uppercase text-[#F5F5F0]/80 hover:text-[#F25C32] transition-colors group"
            data-testid="hero-cta-conoce-mas"
          >
            Conoce más
            <ArrowDown size={16} className="group-hover:translate-y-1 transition-transform" />
          </a>
        </div>
      </div>

      {/* Marquee bar */}
      <div className="absolute bottom-0 left-0 right-0 border-t border-white/10 py-5 overflow-hidden">
        <div className="marquee-track text-xs tracking-[0.3em] uppercase text-[#9CA3AF]">
          {Array(2)
            .fill(0)
            .map((_, i) => (
              <React.Fragment key={i}>
                <span>Actuación</span>
                <span className="text-[#F25C32]">·</span>
                <span>Locución</span>
                <span className="text-[#F25C32]">·</span>
                <span>Doblaje</span>
                <span className="text-[#F25C32]">·</span>
                <span>Audiolibros</span>
                <span className="text-[#F25C32]">·</span>
                <span>Comerciales</span>
                <span className="text-[#F25C32]">·</span>
                <span>Radio Duna 89.7 FM</span>
                <span className="text-[#F25C32]">·</span>
                <span>Documentales</span>
                <span className="text-[#F25C32]">·</span>
              </React.Fragment>
            ))}
        </div>
      </div>
    </section>
  );
}
